export default {"src":"/_next/static/media/WidgetTxHistoryIcon.d820df61.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};